import React from 'react';
import { motion } from 'framer-motion';
export function LetterBody() {
  return <section className="w-full px-6 py-12 bg-cream" data-id="element-47">
      <div className="max-w-reading mx-auto space-y-16" data-id="element-48">
        {/* Section A: The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-49">
          <h2 className="text-3xl md:text-4xl text-brown mb-8" data-id="element-50">
            Si tu cabeza no se apaga, esto es para ti.
          </h2>

          <div className="space-y-6 text-lg text-brown/90 leading-relaxed" data-id="element-51">
            <p data-id="element-52">Este no es otro planner.</p>
            <p data-id="element-53">No es otra rutina.</p>
            <p data-id="element-54">No es un PDF bonito para sentir que "ahora sí".</p>
            <p data-id="element-55">
              Es un sistema para un problema específico:{' '}
              <span className="font-semibold text-brown" data-id="element-56">
                la carga mental del bebé.
              </span>
            </p>
            <p data-id="element-57">
              Esa lista infinita de cosas que no se ven, pero si tú no las
              sostienes… se cae todo.
            </p>
            <p data-id="element-58">Y lo más pesado no es hacerlo.</p>
            <p className="font-medium italic text-brown" data-id="element-59">
              Lo más pesado es ser la gerente invisible.
            </p>
          </div>
        </motion.div>

        {/* Section B: The Hidden Load */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-60">
          <h3 className="text-2xl md:text-3xl text-brown mb-6" data-id="element-61">
            Lo que casi nadie te dice
          </h3>

          <div className="pl-6 border-l-2 border-ochre/30 space-y-3 mb-8 italic text-brown/80" data-id="element-62">
            <p data-id="element-63">¿Dónde están las toallitas?</p>
            <p data-id="element-64">¿Qué talla usa ahora?</p>
            <p data-id="element-65">¿A qué hora le toca?</p>
            <p data-id="element-66">¿Le hace mal esto?</p>
            <p data-id="element-67">¿Qué llevo en la bolsa?</p>
          </div>

          <div className="space-y-6 text-lg text-brown/90 leading-relaxed" data-id="element-68">
            <p data-id="element-69">Parece normal.</p>
            <p data-id="element-70">
              Hasta que te das cuenta de que esas preguntas no son inocentes.
            </p>
            <p data-id="element-71">
              Son una forma de dejar en tu cabeza:
              <span className="block mt-2 font-medium text-brown" data-id="element-72">
                pensar, decidir, coordinar, prevenir, cerrar cabos.
              </span>
            </p>
            <p data-id="element-73">Y tú no necesitas más tareas.</p>
            <p className="text-xl font-serif text-ochre" data-id="element-74">
              Necesitas menos pestañas abiertas.
            </p>
          </div>
        </motion.div>

        {/* Section C: Why Help Fails */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white/40 p-8 rounded-2xl border border-white/60 shadow-sm" data-id="element-75">
          <h3 className="text-2xl md:text-3xl text-brown mb-6" data-id="element-76">
            Por qué "ayuda" te deja igual (aunque te quieran)
          </h3>

          <div className="space-y-6 text-lg text-brown/90 leading-relaxed" data-id="element-77">
            <p data-id="element-78">Porque ayuda suele ser esto:</p>
            <p data-id="element-79">Tú piensas. Tú planeas. Tú recuerdas.</p>
            <p data-id="element-80">La otra persona ejecuta cuando tú lo pides.</p>
            <p data-id="element-81">Eso no es alivio mental.</p>
            <p className="text-xl font-bold text-brown" data-id="element-82">
              Eso es ser jefa con sueño.
            </p>
            <p data-id="element-83">
              Y ser jefa con sueño… te vuelve irritable, controladora o triste.
            </p>
            <p data-id="element-84">
              No porque seas mala.{' '}
              <span className="italic" data-id="element-85">Porque estás saturada.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}